(function () {
  'use strict';

  var selectedRakhiVariantId = null;

  // Store selected Rakhi
  document.addEventListener('change', function (e) {
    if (e.target && e.target.classList.contains('rakhi-radio-input')) {
      selectedRakhiVariantId = e.target.value;
    }
  });

  // Find existing product form
  function getProductForm() {
    return (
      document.querySelector('form[action="/cart/add"]') ||
      document.querySelector('.product-form form') ||
      document.querySelector('form.product__form') ||
      document.querySelector('[data-product-form]')
    );
  }

  // Get selected Pen variant ID
  function getPenVariantId(form) {
    var input =
      form.querySelector('input[name="id"]') ||
      form.querySelector('select[name="id"]');
    return input ? input.value : null;
  }

  // Trigger cart drawer or redirect
  function triggerCartUpdate() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        // Dispatch common cart events
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart }, bubbles: true }));

        // Try Tinker cart drawer
        var drawerTrigger =
          document.querySelector('[data-cart-drawer-trigger]') ||
          document.querySelector('[data-open-cart]') ||
          document.querySelector('.js-cart-open') ||
          document.querySelector('[aria-controls="cart-drawer"]');

        if (drawerTrigger) {
          drawerTrigger.click();
        } else {
          window.location.href = '/cart';
        }
      });
  }

  // Intercept Add to Cart
  function interceptAddToCart() {
    var form = getProductForm();
    if (!form) return;

    form.addEventListener('submit', function (e) {
      if (!selectedRakhiVariantId) return; // Normal behavior if no Rakhi selected

      e.preventDefault();
      e.stopImmediatePropagation();

      var penVariantId = getPenVariantId(form);
      if (!penVariantId) {
        form.submit();
        return;
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [
            { id: parseInt(penVariantId), quantity: 1 },
            { id: parseInt(selectedRakhiVariantId), quantity: 1 }
          ]
        })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Failed');
          return res.json();
        })
        .then(function () {
          triggerCartUpdate();
        })
        .catch(function () {
          form.submit();
        });
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', interceptAddToCart);
  } else {
    interceptAddToCart();
  }

})();
